import React, { useEffect, useState } from "react";
import Container from "@/components/container/Container";
import GeneralCard from "@/components/card/GeneralCard";
import { Col, Divider, Flex } from "antd";
import "@/styles/pages/checkout/checkout-preview.scss";
import IconSessionName from "@/components/icons/IconSessionName";
import IconCalender from "@/components/icons/IconCalender";
import IconSessionTime from "@/components/icons/IconSessionTime";
import IconUserProfile from "@/components/icons/IconUserProfile";
import { useSelector } from "react-redux";
import { getCheckoutType, getProductData, getSessionData } from "@/reducers/checkoutSlice";
import PaymentMethod from "@/pages/checkout/PaymentMethod";
import IconBrochure from "@/components/icons/IconBrochure";
import moment from "moment";
import { getCountryTimeZone } from "@/helpers/getCountryZone";

const CheckoutPreview = () => {
  const isProductType = useSelector(getCheckoutType);
  const productData = useSelector(getProductData);
  const sessionData = useSelector(getSessionData);
  const [timezone, setTimezone] = useState();

  console.log("sessionData", sessionData);

  useEffect(() => {
    setTimezone(getCountryTimeZone());
  }, []);

  return (
    <Container className="checkout-preview-wrapper">
      <GeneralCard className="checkout-card">
        <Flex style={{ width: "100%" }} justify="space-between" wrap>
          <Col xs={24} lg={11} className="card-wrapper pink-bg">
            {!isProductType ? (
              <Flex className="content-wrapper summary-card" vertical gap="5px">
                <div className="title-h6-1">Session Purchase Summary</div>
                <Divider style={{ margin: "4px 0" }} />
                <Flex className="" align="center" gap="0.5rem">
                  <IconSessionName />
                  <Flex className="body-b1">1-on-1 Call Session</Flex>
                </Flex>
                <Flex align="center" gap="0.5rem">
                  <IconCalender />
                  <Flex className="body-b3" gap="4px">
                    <span>Date:</span>
                    <span className="color-dark">{sessionData.date}</span>
                  </Flex>
                </Flex>
                <Flex align="center" gap="0.5rem">
                  <IconSessionTime />
                  <Flex className="body-b3" gap="4px">
                    <span>Time:</span>
                    <span className="color-dark">
                      {sessionData?.time[0]?.localStart} {timezone ? `(${timezone})` : ""}
                    </span>
                  </Flex>
                </Flex>
                <Flex align="center" gap="0.5rem">
                  <IconUserProfile />
                  <Flex className="body-b3" gap="4px">
                    <span>Duration:</span>
                    <span className="color-dark">{sessionData.duration}</span>
                  </Flex>
                </Flex>
                <Flex align="center" gap="0.5rem">
                  <IconSessionName />
                  <Flex className="body-b3" gap="4px">
                    <span>Mentor:</span>
                    <span className="color-dark">{sessionData.guideName}</span>
                  </Flex>
                </Flex>
              </Flex>
            ) : (
              <Flex className="content-wrapper summary-card" vertical gap="5px">
                <div className="title-h6-1">Purchase Summary</div>
                <Divider style={{ margin: "4px 0" }} />
                <Flex className="" align="center" gap="0.5rem">
                  <IconSessionName />
                  <Flex className="" align="center" gap="0.5rem">
                    <span className="body-b3">Product:</span>
                    <span className="body-b1 color-dark">{productData?.title}</span>
                  </Flex>
                </Flex>
                <Flex align="center" gap="0.5rem">
                  <IconBrochure />
                  <Flex align="center" className="body-b3" gap="4px">
                    <span className="body-b3">Plan Price:</span>
                    <span className="body-b1 color-dark">
                      {productData.price === 0 ? null : "£"}
                      {productData.price === 0 ? "Free" : productData.price}{" "}
                      {productData.stage === "Membership" && !productData.isComplimentary
                        ? "/month"
                        : ""}
                    </span>
                  </Flex>
                </Flex>
              </Flex>
            )}
            <Flex className="breakout-summary" vertical>
              <Flex className="body-b1-2 color-dark" justify="space-between">
                <span>Purchase Date</span>
                <span>{moment().format("DD MMM YYYY")}</span>
              </Flex>
              <Flex className="body-b1-2" justify="space-between">
                <span>Subtotal</span>
                <span>
                  £{isProductType ? productData.price : sessionData.price}
                  {isProductType && productData.discount ? (
                    <span style={{ color: "green", marginLeft: "8px" }}>
                      -{productData.discount}%
                    </span>
                  ) : null}
                  {!isProductType && sessionData.discount ? (
                    <span style={{ color: "green", marginLeft: "8px" }}>
                      -{sessionData.discount}%
                    </span>
                  ) : null}
                </span>
              </Flex>

              <Divider />

              <Flex className="body-b1-2" justify="space-between">
                <span>Total</span>
                <span className="title-h6-1">
                  {isProductType
                    ? productData.price === 0
                      ? ""
                      : "£"
                    : sessionData.price === 0
                      ? ""
                      : "£"}
                  {isProductType
                    ? productData.price === 0
                      ? "Free"
                      : (productData.price * (1 - (productData.discount || 0) / 100)).toFixed(2)
                    : sessionData.price === 0
                      ? "Free"
                      : (sessionData.price * (1 - (sessionData.discount || 0) / 100)).toFixed(2)}
                </span>
              </Flex>
            </Flex>{" "}
            {/* Add note */}
            {/* Session Recording and Transcription will be made available after the session is over. */}
            <Flex
              className="add-note"
              style={{
                background: "white",
                marginTop: "1rem",
                padding: "1rem",
                borderRadius: "8px",
                border: "1px solid #E5E5E5",
              }}
            >
              <p>
                <span className="body-b3" style={{ fontWeight: 500 }}>
                  Note:
                </span>{" "}
                <span className="body-b3">
                  Session Recording and Transcription will be made available after the session is
                  over.
                </span>
              </p>
            </Flex>
          </Col>

          <div className="divder"></div>
          <PaymentMethod
            amount={isProductType ? productData.price : sessionData.price}
            data={isProductType ? productData : sessionData}
            isProductType={isProductType}
          />
        </Flex>
      </GeneralCard>
    </Container>
  );
};

export default CheckoutPreview;
